import { render, staticRenderFns } from "./AsthmaInfoDialogActivator.vue?vue&type=template&id=59b86e6b&"
import script from "./AsthmaInfoDialogActivator.vue?vue&type=script&lang=js&"
export * from "./AsthmaInfoDialogActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports